<template>
    <div ref="widgetContainer" class="w-full"></div>
  </template>
  
  <script>

  import { IntakeFormWidget } from '../../libs/al-intake-widget/dist/intake-form.js';

 const WIDGET_EVENT_NAMES_TO_EXPOSE = [
    'leadClickedIssueInput',
    'issueTextUpdated',
    'issueSubmitted',
    'jurisdictionTextUpdated',
    'jurisdictionSelectionChange',
    'jurisdictionSelectionSubmitted',
    'nameTextUpdated',
    'emailTextUpdated',
    'phoneNumberUpdated',
    'contactDetailsSubmitted',
    'intakeComplete',
  ];
  
  export default {
    name: 'IntakeFormWrapper',
    props: {
      apiUrl: {
        type: String,
        required: true,
      },
      apiToken: {
        type: String,
        default: undefined,
      },
      apiHeaders: {
        type: Object,
        default: () => ({}),
      },
      showInitialMessage: {
        type: Boolean,
        default: undefined,
      },
      showLastMessage: {
        type: Boolean,
        default: undefined,
      },
    },
    data() {
      return {
        widgetInstance: null,
        intakeElement: null,
        eventHandlers: {},
      };
    },
    watch: {
      apiUrl(newVal) { this.updateWidgetConfig({ apiUrl: newVal }); },
      apiToken(newVal) { this.updateWidgetConfig({ apiToken: newVal }); },
      apiHeaders(newVal) { this.updateWidgetConfig({ apiHeaders: newVal }); },
      showInitialMessage(newVal) { this.updateWidgetConfig({ showInitialMessage: newVal }); },
      showLastMessage(newVal) { this.updateWidgetConfig({ showLastMessage: newVal }); },
    },
    mounted() {
      if (this.$refs.widgetContainer && typeof IntakeFormWidget !== 'undefined') {
        const initialConfig = {
          apiUrl: this.apiUrl,
          apiToken: this.apiToken,
          apiHeaders: this.apiHeaders,
        };
        if (this.showInitialMessage !== undefined) {
          initialConfig.showInitialMessage = this.showInitialMessage;
        }
        if (this.showLastMessage !== undefined) {
          initialConfig.showLastMessage = this.showLastMessage;
        }
  
        this.widgetInstance = IntakeFormWidget.render(
          this.$refs.widgetContainer,
          initialConfig
        );
  
        this.intakeElement = this.$refs.widgetContainer.querySelector('intake-form');
  
        if (this.intakeElement) {
          this.addEventListeners();
        } else {
          console.error('[IntakeFormWrapper] Could not find <intake-form> element after render.');
        }
      } else if (typeof IntakeFormWidget === 'undefined') {
        console.error('[IntakeFormWrapper] IntakeFormWidget is not available globally.');
      }
    },
    beforeDestroy() {
      if (this.intakeElement) {
        this.removeEventListeners();
      }
      if (this.widgetInstance && typeof this.widgetInstance.unmount === 'function') {
        this.widgetInstance.unmount();
        this.widgetInstance = null;
      }
      this.intakeElement = null;
    },
    methods: {
      updateWidgetConfig(newConfigPartial) {
        if (this.widgetInstance && typeof this.widgetInstance.updateConfig === 'function') {
          this.widgetInstance.updateConfig(newConfigPartial);
        }
      },
      addEventListeners() {
        WIDGET_EVENT_NAMES_TO_EXPOSE.forEach(eventName => {
          const vueEventName = eventName.replace(/([A-Z])/g, '-$1').toLowerCase();
          const handler = (event) => {
            this.$emit(vueEventName, event.detail);
          };
          this.eventHandlers[eventName] = handler;
          this.intakeElement.addEventListener(eventName, handler);
        });
      },
      removeEventListeners() {
        WIDGET_EVENT_NAMES_TO_EXPOSE.forEach(eventName => {
          if (this.eventHandlers[eventName]) {
            this.intakeElement.removeEventListener(eventName, this.eventHandlers[eventName]);
            delete this.eventHandlers[eventName];
          }
        });
      },
    },
  };
  </script>
  
  <style scoped>
  /* div[ref="widgetContainer"] {
    min-height: 300px;
  } */
  </style>